// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".recruiter__content[data-v-6dce5384]{width:calc(100% - 300px);display:flex;flex-direction:column}.recruiter__small[data-v-6dce5384]{width:100%}", ""]);
// Exports
module.exports = exports;
